export default "/_next/static/images/dailyRewardsBubbleBg-844155dbb79bda762c7e194365c79c0a.png";